export const profileCard = () => {
  const component = document.querySelector("[data-wm-profile-card]");

  if (!component) {
    return;
  }

  const details = ["first_name", "last_name", "postal", "country", "email"];

  const updateProfileDetails = (event) => {
    const data = event.detail.payload;

    details.forEach((detail) => {
      const detailElement = component.querySelector(
        `[data-wm-profile-card-detail="${detail}"]`
      );
      detailElement.innerHTML = data.get(detail);
    });
  };

  document.addEventListener("wm-userProfileUpdated", updateProfileDetails);
};
